<template>
  <div class="notes-thread" v-if="notes.length > 0">
    <div
      v-for="note in notes"
      :key="note.id"
      class="note-item"
      :class="{ internal: note.is_internal }"
    >
      <div class="note-header">
        <span class="note-author" :class="note.author_type">
          {{ note.author_type }}
        </span>
        <span v-if="note.is_internal" class="note-internal-badge">Internal</span>
        <span class="note-date">{{ formatDate(note.created_at) }}</span>
      </div>
      <div class="note-content">{{ note.content }}</div>
    </div>
  </div>
  <p v-else class="empty-text">{{ $t('case.noNotes') }}</p>
</template>

<script setup>
import dayjs from 'dayjs'

defineProps({
  notes: { type: Array, default: () => [] },
})

const formatDate = (date) => {
  if (!date) return ''
  return dayjs(date).format('DD MMM YYYY, HH:mm')
}
</script>

<style scoped>
.notes-thread {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.note-item {
  padding: var(--space-4);
  border: 1px solid var(--color-gray-200);
  border-radius: var(--radius-md);
  background: var(--color-white);
}

.note-item.internal {
  background: #fef9c3;
  border-color: #fde68a;
}

.note-header {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  margin-bottom: var(--space-2);
}

.note-author {
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 2px 8px;
  border-radius: var(--radius-sm);
}

.note-author.user {
  background: #dbeafe;
  color: #1e40af;
}

.note-author.scholar {
  background: #dcfce7;
  color: #166534;
}

.note-author.system {
  background: var(--color-gray-100);
  color: var(--color-gray-600);
}

.note-internal-badge {
  font-size: var(--font-size-xs);
  color: #92400e;
  background: #fde68a;
  padding: 1px 6px;
  border-radius: var(--radius-sm);
}

.note-date {
  font-size: var(--font-size-xs);
  color: var(--color-gray-400);
  margin-left: auto;
}

.note-content {
  font-size: var(--font-size-sm);
  color: var(--color-charcoal);
  line-height: 1.6;
  white-space: pre-wrap;
}

.empty-text {
  text-align: center;
  color: var(--color-gray-500);
  padding: var(--space-6);
}
</style>
